"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var identity_1 = tslib_1.__importDefault(require("./identity"));
var pipe_1 = tslib_1.__importDefault(require("./pipe"));
function evolve(transformation, obj) {
    if (obj === undefined) {
        return function (obj) { return evolve(transformation, obj); };
    }
    return (0, pipe_1.default)(Object.entries(obj), function (entries) {
        return entries.map(function (_a) {
            var _b;
            var _c = tslib_1.__read(_a, 2), k = _c[0], v = _c[1];
            return [k, ((_b = transformation[k]) !== null && _b !== void 0 ? _b : identity_1.default)(v)];
        });
    }, Object.fromEntries);
}
exports.default = evolve;
//# sourceMappingURL=evolve.js.map